'use client';

import { createContext, useContext } from 'react';

export interface TabsContextProps {
  activeTabId: string;
  setActiveTabId: (id: string) => void;
  persist?: boolean;
}

export const TabsContext = createContext<TabsContextProps>({
  activeTabId: '',
  setActiveTabId: () => {},
  persist: false,
});

export const useTabsContext = () => useContext(TabsContext);
